var map = {
	"./add-white.svg": 915,
	"./add.svg": 9475,
	"./alert-circle.svg": 6477,
	"./alert-white.svg": 2576,
	"./arrow-back.svg": 2063,
	"./broken-image.svg": 7021,
	"./btn-add.svg": 6152,
	"./check-circle-green.svg": 6589,
	"./check-square-green.svg": 9944,
	"./check-white.svg": 1530,
	"./clipboard-white.svg": 8796,
	"./clipboard.svg": 2188,
	"./clock-grey.svg": 1468,
	"./clock.svg": 236,
	"./close-black.svg": 1944,
	"./close-white.svg": 86,
	"./edit-white.svg": 6,
	"./edit.svg": 9338,
	"./file-text-black.svg": 9622,
	"./file-text.svg": 2412,
	"./folder-plus-black.svg": 3433,
	"./folder-plus.svg": 2575,
	"./fullscreen-close.svg": 118,
	"./fullscreen.svg": 2885,
	"./menu-black.svg": 5305,
	"./menu-white.svg": 1951,
	"./mic.svg": 6871,
	"./minus.svg": 8682,
	"./notFound.svg": 5723,
	"./plus-red.svg": 9376,
	"./plus-white.svg": 8686,
	"./plus.svg": 4034,
	"./questionMark.svg": 5169,
	"./refresh.svg": 3571,
	"./scale-black.svg": 3442,
	"./scale.svg": 7208,
	"./tag-black.svg": 1748,
	"./tag.svg": 1718,
	"./x-red.svg": 6264,
	"./xCircle-white.svg": 3374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4500;